function hexToRgb(hex) {
  // Remove the "#" if present
  hex = hex.replace(/^#/, '');

  // Parse into RGB values
  let bigint;
  if (hex.length === 3) { // Short form #RGB
    bigint = parseInt(hex.split('').map(c => c + c).join(''), 16);
  } else { // Full form #RRGGBB
    bigint = parseInt(hex, 16);
  }

  return [
    (bigint >> 16) & 255, // Red
    (bigint >> 8) & 255,  // Green
    bigint & 255          // Blue
  ];
}

function getLuminance(r, g, b) {
  // Convert RGB to a luminance value
  const a = [r, g, b].map(v => {
    v /= 255; // Normalize to range [0, 1]
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

export function getContrastRatio(hex1, hex2) {
  // Convert hex to RGB
  const rgb1 = hexToRgb(hex1);
  const rgb2 = hexToRgb(hex2);

  // Calculate luminance
  const luminance1 = getLuminance(rgb1[0], rgb1[1], rgb1[2]);
  const luminance2 = getLuminance(rgb2[0], rgb2[1], rgb2[2]);

  // Ensure L1 is the lighter color
  const L1 = Math.max(luminance1, luminance2);
  const L2 = Math.min(luminance1, luminance2);

  return (L1 + 0.05) / (L2 + 0.05);
}
